module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-data"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('v-form', {
    ref: "form",
    staticClass: "page-content-body__form",
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.controls.showDialog = true
      }
    },
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n          Collection Details\n        ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Logbook Number",
      "disabled": ""
    },
    model: {
      value: (_vm.newLogData.logbookNumber),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "logbookNumber", $$v)
      },
      expression: "newLogData.logbookNumber"
    }
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "input-group--limit-height",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.showDatepicker),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDatepicker", $$v)
      },
      expression: "controls.showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Collection Date(YYYY-MM-DD)",
      "append-icon": "event",
      "rules": [function (v) { return !!v || 'Collection Date is required'; }],
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionDate", $$v)
      },
      expression: "newLogData.collectionDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "primary": "",
            "flat": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.newLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionDate", $$v)
      },
      expression: "newLogData.collectionDate"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "input-group--limit-height",
    attrs: {
      "items": _vm.collectionSites,
      "label": "Collection Site",
      "autocomplete": "",
      "item-text": "logbookAbbv",
      "rules": [function (v) { return !!v || 'Collection Site is required'; }],
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.selectedSite),
      callback: function($$v) {
        _vm.selectedSite = $$v
      },
      expression: "selectedSite"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "name": "input-5-1",
      "label": "Notes"
    },
    model: {
      value: (_vm.newLogData.notes),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "notes", $$v)
      },
      expression: "newLogData.notes"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.collectionTimeMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "collectionTimeMenu", $$v)
      },
      expression: "controls.collectionTimeMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Collection Time",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionTime", $$v)
      },
      expression: "newLogData.collectionTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionTime", $$v)
      },
      expression: "newLogData.collectionTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Rainfall (in) [trace = 0.001]",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.precipitation
    },
    model: {
      value: (_vm.newLogData.precipitation),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "precipitation", $$v)
      },
      expression: "newLogData.precipitation"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "form-input-sub-text",
    attrs: {
      "target": "_blank",
      "href": "https://www.wunderground.com/history/"
    }
  }, [_vm._v("Rainfall value from Weather Underground")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Analyst (Initials)",
      "required": "",
      "rules": _vm.formRules.required
    },
    model: {
      value: (_vm.newLogData.analyst),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "analyst", $$v)
      },
      expression: "newLogData.analyst"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n          Incubation and Parameters\n        ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationInMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationInMenu", $$v)
      },
      expression: "controls.incubationInMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Incubation In Time",
      "rules": _vm.formRules.incubationTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTime", $$v)
      },
      expression: "newLogData.incubationTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTime", $$v)
      },
      expression: "newLogData.incubationTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Incubation Temp (*C)",
      "type": "number",
      "rules": _vm.formRules.incubationTempRules
    },
    model: {
      value: (_vm.newLogData.incubationTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTemp", $$v)
      },
      expression: "newLogData.incubationTemp"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationOutMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationOutMenu", $$v)
      },
      expression: "controls.incubationOutMenu"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Incubation Out Time",
      "rules": _vm.formRules.incubationOutTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationOut", $$v)
      },
      expression: "newLogData.incubationOut"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationOut", $$v)
      },
      expression: "newLogData.incubationOut"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "# mL/100mL (Dilution)",
      "type": "number",
      "rules": _vm.formRules.dilutionRules
    },
    model: {
      value: (_vm.newLogData.dilution),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "dilution", $$v)
      },
      expression: "newLogData.dilution"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Fluorometry",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.fluorometryRules
    },
    model: {
      value: (_vm.newLogData.fluorometry),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "fluorometry", $$v)
      },
      expression: "newLogData.fluorometry"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Turbidity (NTU)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.turbidityRules
    },
    model: {
      value: (_vm.newLogData.turbidity),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "turbidity", $$v)
      },
      expression: "newLogData.turbidity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Conductivity (µS)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.conductivityRules
    },
    model: {
      value: (_vm.newLogData.specificConductivity),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "specificConductivity", $$v)
      },
      expression: "newLogData.specificConductivity"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Typical range for Conductivity is 0 - 750")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column page-content-body__column--end"
  }, [_c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n            Total Coliform\n          ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.newLogData.coliformLargeCells),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "coliformLargeCells", $$v)
      },
      expression: "newLogData.coliformLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.newLogData.coliformSmallCells),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "coliformSmallCells", $$v)
      },
      expression: "newLogData.coliformSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("Total Coliform (MPN/100mL) = " + _vm._s(_vm.getTotalColiform))]), _vm._v(" "), _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n            E. coli\n          ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.ecoliLargeCells),
      callback: function($$v) {
        _vm.ecoliLargeCells = $$v
      },
      expression: "ecoliLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.ecoliSmallCells),
      callback: function($$v) {
        _vm.ecoliSmallCells = $$v
      },
      expression: "ecoliSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("E. coli (MPN/100mL) = " + _vm._s(_vm.getTotalEcoli))]), _vm._v(" "), (_vm.controls.showAdditionalParams === false) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n          See More Parameters\n        ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n          Hide More Parameters\n        ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header page-content-body__header--space-above"
  }, [_vm._v("\n            Additional Parameters\n          ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Air Temperature (*C)",
      "type": "number"
    },
    model: {
      value: (_vm.newLogData.airTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "airTemp", $$v)
      },
      expression: "newLogData.airTemp"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Ammonium (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.ammonium),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "ammonium", $$v)
      },
      expression: "newLogData.ammonium"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Chlorophyll a (µg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.chlorophyll),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "chlorophyll", $$v)
      },
      expression: "newLogData.chlorophyll"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Dissolved Oxygen (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.dissolvedOxygen),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "dissolvedOxygen", $$v)
      },
      expression: "newLogData.dissolvedOxygen"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Nitrate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.nitrate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "nitrate", $$v)
      },
      expression: "newLogData.nitrate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Phosphate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.phosphate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "phosphate", $$v)
      },
      expression: "newLogData.phosphate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Secchi Depth (meters)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.secchiDepth),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "secchiDepth", $$v)
      },
      expression: "newLogData.secchiDepth"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Total Chlorine (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.totalChlorine),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "totalChlorine", $$v)
      },
      expression: "newLogData.totalChlorine"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Water Temperature (*C)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.waterTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "waterTemp", $$v)
      },
      expression: "newLogData.waterTemp"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "btn-nww log-data-submit-btn",
    attrs: {
      "slot": "activator",
      "type": "submit"
    },
    slot: "activator"
  }, [_vm._v("\n            " + _vm._s("Log Data") + "\n          ")]), _vm._v(" "), _c('v-card', {
    staticClass: "card-alert"
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline log-data-confirm__header"
  }, [_vm._v("Log Data?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Please confirm that you would like to log data")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.controls.showDialog = false
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitLog($event)
      }
    }
  }, [_vm._v("\n                Confirm\n              ")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.errorMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.successMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n      Log Data\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-content-header__subtext--dark"
  }, [_vm._v("\n      Log new data for a collection site\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20718eb9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/LogData.vue
// module id = 440
// module chunks = 1